// extracted by mini-css-extract-plugin
module.exports = {"icon_wrapper":"common-styles_icon_wrapper__1Ye-L","icon_header":"common-styles_icon_header__1wOvk"};